function Overlay({extraClasses, children}) {
  return (
    <div className={`app-overlay ${extraClasses}`}>
      <div className="col-wrapper">{children}</div>
    </div>
  )
}

export default Overlay
